import React from "react";
import GlobalURL from "../baseUrl";
import "./pstyle.css";
import { useState } from "react";
import "../fonts.css";
import { MDBContainer, MDBInput } from "mdb-react-ui-kit";

import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import translations from "../locals/translation";
import { IoMdArrowBack } from "react-icons/io";

function Forgetpassword() {
  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState("");
  const [showMes, setShowMes] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpsent, setOtpsent] = useState(false);
  const [fPScreen, setFPScreen] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const forgetPassword = async () => {
    setShowMes(false);
    setOtpsent(false);
    setLoading(true);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    emailRegex.test(email);
    if (!emailRegex.test(email)) {
      setInvalidEmail(true);
      setLoading(false);
      return;
    }

    if (email === "") {
      setMessage(t("Please enter your registered email address"));
      setShowMes(true);
      setLoading(false);
      return;
    }
    try {
      const apiUrl = `${GlobalURL}/api/dev/admin/auth/forgotPassword`;
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          lang_id: language,
        },
        body: JSON.stringify({ email: email }),
      });

      const data = await res.json();

      if (data.status_code === 200) {
        setOtpsent(true);
        setLoading(false);
        setShowMes(false);
        setFPScreen(true);
        setUserId(data.data[0].id); // setting userID;
        setLoading(false);
        return;
      }
      if (data.status_code === 400) {
        setShowMes(true);
        setMessage(data.message);
        setLoading(false);
        return;
      } else {
        setShowMes(true);
        setLoading(false);
        setShowMes(t("¡Error del Servidor!"));
        return;
      }
    } catch (error) {
      setLoading(false);
      setShowMes(true);
      setShowMes(t("¡Error del Servidor!"));
      console.error("Error logging in:", error.message);
    }
  };
  const resendOTP = async () => {
    if (email === "") {
      setMessage(t("Please enter your email address first"));
      setShowMes(true);
      return;
    }
    setShowMes(false);
    // setOtpsent(false);
    setLoading(true);
    try {
      const apiUrl = `${GlobalURL}/api/dev/admin/auth/forgotPassword`;
      // Replace with your actual API endpoint

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          lang_id: language,
        },
        body: JSON.stringify({ email: email }),
      });
      const data = await response.json();

      if (data.status_code === 200) {
        setOtpsent(true);
        setLoading(false);
        setShowMes(false);
        setFPScreen(true);
        setUserId(data.data[0].id); // setting userID;
        setLoading(false);
      } else if (data.status_code === 404) {
        setShowMes(true);
        setMessage(data.message);
        setLoading(false);
        return;
      } else {
        setShowMes(true);
        setMessage(t("Server Error!"));
        return;
      }
    } catch (error) {
      setLoading(false);
      setShowMes(true);
      setMessage(t("Server Error!"));
      console.error("Error logging in:", error.message);
      Swal.fire(t("Server Error!"));
    }
  };
  const adminVeritfy = async () => {
    if (email === "") {
      setMessage(t("enter OTP first"));
      setShowMes(true);
      return;
    }
    setLoading(true);
    try {
      const apiUrl = `${GlobalURL}/api/dev/admin/auth/verifyResetPassword`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          lang_id: language,
        },
        body: JSON.stringify({
          otp: Number(otp),
          id: userId,
        }),
      });

      const res = await response.json();

      if (res.status_code === 200) {
        localStorage.setItem("token", res.data[0].token);
        setLoading(false);
        setShowMes(false);
        navigate("/resetpassword");
      } else if (res.status_code === 401) {
        setLoading(false);
        setShowMes(true);
        setShowMes(res.message);
      } else if (res.status_code === 400) {
        setShowMes(true);
        setLoading(false);
        setMessage(res.message);
        return;
      } else if (res.status_code === 422) {
        setLoading(false);
        setShowMes(true);
        setShowMes(res.message);
      } else {
        setShowMes(true);
        setShowMes(t("Server Error!"));
      }
    } catch (error) {
      setMessage(t("Server Error!"));
      setShowMes(true);
      console.error("Error logging in:", error.message);
    }
  };
  const resetEmail = () => {
    setFPScreen(false);
    setOtpsent(false);
    setShowMes(false);
  };

  return (
    <>
      <div className="body-container">
        <div className="login-form-outer">
          <div className="logo-in-login">
            <img src="./img/sideLogo.png" alt="logo" />
          </div>
          <MDBContainer
            className=" my-0 d-flex flex-column w-25"
            id="border-login-form2"
          >
            <div className="login-heading">
              <h1>{fPScreen ? t("OTP verification") : t("Forgot Password")}</h1>
              <h5>
                {t(
                  `Please enter your email address to reset your password. Once submitted, you'll receive a One Time Password (OTP) to complete the process.`
                )}
              </h5>
            </div>
            <div className="message-on-login">
              <p>{showMes && message}</p>
            </div>
            <div className="login-form-headings">
              <p style={{ opacity: fPScreen ? 0.8 : 1 }}>
                {t("Please enter your registered email address")}
              </p>
            </div>
            <MDBInput
              required={true}
              autoCapitalize="false"
              autoComplete="false"
              autoCorrect="false"
              wrapperClass={`mb-4`}
              placeholder={t("example@gmail.com")}
              disabled={fPScreen}
              id="form1"
              type="email"
              style={{ borderColor: invalidEmail ? "red" : "tan" }}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setInvalidEmail(false);
              }}
            />
            {invalidEmail && (
              <p style={{ color: "red", marginTop: "-23px" }}>
                Please enter a valid Email.
              </p>
            )}
            {fPScreen && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  marginBottom: "10px",
                }}
              >
                {" "}
                <p
                  style={{
                    color: "#146EFD",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    resetEmail();
                  }}
                >
                  {t("Reset Email")}
                </p>
              </div>
            )}
            <div className="text-center"></div>
            {otpsent && (
              <div style={{ marginTop: "0px" }}>
                <div className="login-form-headings">
                  <p>
                    {t("Enter OTP")} (
                    {t(
                      "We have sent the OTP to your registered email, please check and enter below"
                    )}
                    )
                  </p>
                </div>
                <MDBInput
                  wrapperClass="mb-1"
                  placeholder="OTP"
                  id="form1"
                  type="email"
                  value={otp}
                  required={true}
                  typeof="number"
                  onChange={(e) => {
                    setOtp(e.target.value);
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginBottom: "10px",
                  }}
                >
                  {" "}
                  <p
                    style={{
                      color: "#146EFD",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      resendOTP();
                    }}
                  >
                    {t("Resend OTP")}
                  </p>
                </div>
              </div>
            )}
            <Button
              className="buttons"
              onClick={() => {
                fPScreen ? adminVeritfy() : forgetPassword();
              }}
            >
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="loading-spinner"></div>{" "}
                  <p className="logging-heading"></p>
                </div>
              ) : fPScreen ? (
                t("Verify OTP")
              ) : (
                t("Send OTP")
              )}
            </Button>{" "}
            <div className="d-flex justify-content-between mx-3 mb-4"></div>
            <p
              onClick={() => {
                navigate("/");
              }}
              className="arrow-with-back"
            >
              <IoMdArrowBack />
              Go Back to login screen
            </p>
          </MDBContainer>
        </div>
      </div>
    </>
  );
}

export default Forgetpassword;
